var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "file"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "file1",
    serifid: "file"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-file",
    x: 0,
    y: 0,
    width: 24,
    height: 23.983,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.779,8.105c0,-0.031 -0.012,-0.06 -0.034,-0.082c0,-0 0.05,-0.051 -4.973,-4.974c-0.045,-0.044 -0.048,-0.057 -0.172,-0.057c-6.108,-0 -6.042,-0 -6.042,-0c-1.282,-0 -2.337,1.055 -2.337,2.337l-0,13.325c-0,1.283 1.055,2.338 2.337,2.338l8.884,-0c1.282,-0 2.337,-1.055 2.337,-2.338l0,-10.549Zm-5.23,-3.77l0,2.104c0,0.978 0.805,1.782 1.782,1.782l2.105,0l-0,10.433c-0,0.546 -0.449,0.995 -0.994,0.995l-8.884,-0c-0.545,-0 -0.994,-0.449 -0.994,-0.995l0,-13.325c0,-0.545 0.449,-0.994 0.994,-0.994l5.991,-0Z",
    style: {
      fillRule: "nonzero"
    }
  }), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "pin-map"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRFile);
export default __webpack_public_path__ + "static/media/iconR-file.5f73ccab7e56dcca090902d0e30bd7e6.svg";
export { ForwardRef as ReactComponent };